var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "quickview-modal",
      attrs: { visible: _vm.active },
      on: { "on-close": _vm.close }
    },
    [
      _vm.loading
        ? _c("ui-loader", {
            staticClass: "quickview-modal-loader",
            attrs: { size: "64" }
          })
        : _vm._e(),
      _c("div", { staticClass: "quickview" }, [
        _c(
          "div",
          { staticClass: "quickview-gallery" },
          [
            _c("swiper", {
              attrs: {
                items: _vm.images,
                "slides-to-show": 1,
                dots: "",
                arrows: ""
              },
              on: { change: _vm.onChangeSlide },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("media", {
                        attrs: { media: item, width: "400", alt: _vm.name }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm.product.id
              ? _c("favorite-button", {
                  attrs: {
                    "product-id": _vm.product.id,
                    "product-code": _vm.product.code,
                    "product-price": _vm.currentPrice,
                    "sku-id": _vm.activeSku.id
                  },
                  on: { change: _vm.onChangeFavorite }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "quickview-content" },
          [
            _c("product-markers", {
              attrs: {
                markers: _vm.product.markers,
                plates: _vm.product.plates
              }
            }),
            _c("h1", { staticClass: "quickview-content-title" }, [
              _vm._v("\n        " + _vm._s(_vm.name) + "\n        "),
              _c("span", [_vm._v(_vm._s(_vm.product.code))])
            ]),
            _vm.product.id
              ? [
                  _c("div", { staticClass: "quickview-content-prices" }, [
                    _c(
                      "div",
                      {
                        class: ["price price-rub", { discount: _vm.isDiscount }]
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("price")(_vm.currentPrice)) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm.isDiscount
                      ? _c("div", { staticClass: "old-price" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("price")(_vm.product.price.basePrice)
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c("select-color", {
                    attrs: {
                      "show-color-name": "",
                      label: "Цвета",
                      colors: _vm.colors,
                      "active-color": _vm.product.id,
                      "colors-limit": 10
                    },
                    on: { change: _vm.chooseColor }
                  }),
                  _c(
                    "select-size",
                    {
                      attrs: {
                        "visible-hint": "",
                        label: "Размеры",
                        sizes: _vm.sizes,
                        "active-sku": _vm.activeSku
                      },
                      on: { change: _vm.chooseSize }
                    },
                    [
                      _vm.product.sizeTable
                        ? _c("size-table", {
                            attrs: { "product-id": _vm.product.id },
                            on: { open: _vm.onOpenSizeTable }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "to-cart",
                    {
                      attrs: {
                        product: _vm.product,
                        "sku-id": _vm.activeSku.id
                      },
                      on: {
                        add: _vm.onAddToCart,
                        added: function($event) {
                          _vm.active = false
                        },
                        "to-cart": _vm.onRedirectToCart
                      }
                    },
                    [
                      _c("ui-button", {
                        ref: "detailsBtn",
                        staticClass: "details",
                        attrs: { secondary: "", wide: "", text: "Подробнее" },
                        on: { click: _vm.onClickDetails }
                      })
                    ],
                    1
                  ),
                  !_vm.product.available
                    ? _c("ui-notification", {
                        staticClass: "sold-out",
                        attrs: { title: "Товар распродан" }
                      })
                    : _vm._e(),
                  _c("product-delivery", {
                    staticClass: "quickview__product-delivery",
                    attrs: {
                      "active-sku": _vm.activeSku,
                      "availability-stores": _vm.availabilityStores
                    },
                    on: { click: _vm.onClickProductDelivery }
                  }),
                  _c("product-bonus", { attrs: { bonus: _vm.product.bonus } })
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }